import { createFileRoute } from '@tanstack/react-router';

import { PageContainer } from '../components/layout/page-container';
import { PageHeader } from '../components/ui/page-header';
import { EmptyState } from '../components/ui/empty-state';
import { AdminArticleList } from '../features/articles/admin-article-list';
import { GatePrompt, useActionGate } from '../features/auth/action-gate';
import { useMe } from '../features/auth/use-me';
import { ShieldX } from '@/components/icons';

/**
 * Admin article-approval page (V4 §C). CSR, role === 'admin' gated. A non-admin
 * (anonymous, not-onboarded, or a regular user) is blocked with a message; the
 * server also enforces admin-only on every endpoint (403). Minimal operational
 * UI — a fuller dashboard is a follow-up.
 */
export const Route = createFileRoute('/admin/articles')({
  // 로그인 화면 — 세션이 브라우저에만 있다. 서버는 레이아웃만 그린다(docs/SSR.md).
  ssr: false,
  component: AdminArticlesPage,
});

function AdminArticlesPage() {
  const gate = useActionGate();
  const { data: me } = useMe();

  if (gate !== 'ready') {
    return (
      <PageContainer>
        <PageHeader title="기사 승인" />
        <GatePrompt status={gate} message="관리자만 접근할 수 있어요." />
      </PageContainer>
    );
  }

  if (me?.role !== 'admin') {
    return (
      <PageContainer>
        <PageHeader title="기사 승인" />
        <EmptyState
          icon={<ShieldX />}
          title="관리자만 접근할 수 있는 페이지예요."
        />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader
        title="기사 승인"
        description="승인하면 전지적 좋소 시점 목록에 발행돼요. 익명성(닉네임·회사 초성)과 명예훼손 위험을 확인하고 승인해 주세요."
      />
      <AdminArticleList />
    </PageContainer>
  );
}
